import { render, staticRenderFns } from "./ChannelNew.vue?vue&type=template&id=dfd5ec9a&"
import script from "./ChannelNew.vue?vue&type=script&lang=js&"
export * from "./ChannelNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports